<template>
  <div class="vmp-sign-live" v-if="!auth_gd">
    <vh-dialog
      :title="$t('host.k_596001')"
      :visible.sync="signVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <!-- 签到信息 -->
      <signinSet v-if="showSet && signVisible" @start="startSign"></signinSet>
    </vh-dialog>
    <div class="vmp-sign-live_down" v-if="signinDown">
      <div class="down-container">
        <!-- 签到倒计时弹窗 -->
        <Counter
          @close-sign="closeAutoSignin"
          :autoSign="signInfo.autoSign"
          :title="signInfo.signTip"
          :total="total"
          :remaining="remaining"
          v-if="starting"
          ref="counter"
        ></Counter>
        <!-- 签到结果 -->
        <signinResult
          v-if="showResult"
          @restartsign="resetSignState"
          :room_id="roomId"
          :signId="signId"
        ></signinResult>
        <!-- 定时推送取消界面 -->
        <cancelHandle v-if="pushTime" :pushTime="pushTime" @cancelSign="delSign"></cancelHandle>
        <div class="vmp-sign-live_close" @click="signinDown = false">
          <i class="vh-iconfont vh-line-circle-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';
  import mainMixin from './mixins/main.js';
  export default {
    name: 'VmpSignLive',
    mixins: [mainMixin],
    computed: {
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      }
    }
  };
</script>
<style lang="less">
  .vmp-sign-live {
    &_down {
      position: fixed;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      z-index: 128;
      .down-container {
        height: 469px;
        width: 400px;
        margin-top: 15vh;
        background-image: url('./img/signBox@2x.png');
        background-size: 100% 100%;
        position: relative;
      }
    }
    &_close {
      position: absolute;
      left: 47%;
      bottom: -18px;
      cursor: pointer;
      border-radius: 50%;
      i {
        font-size: 24px;
        color: #fff;
      }
    }
  }
</style>
